import React from 'react';
import { Link } from 'react-router-dom';
import { GoldIcon } from '../icons';

const CreateAccount: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center">
            <GoldIcon className="h-12 w-12 text-gold-500" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Создание аккаунта
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            Регистрация временно недоступна
          </p>
        </div>
        
        <div className="text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Для доступа к системе обратитесь к администратору
          </p>
          <Link
            to="/login"
            className="font-medium text-gold-600 hover:text-gold-500"
          >
            Вернуться к входу
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
